import React, { Component } from "react";
import { connect } from "react-redux";
import Checkbox from "../../../../components/Checkbox";
import Counter from "../../../../components/Counter";
import Input from "../../../../components/Input";
import Wrapper from "../../../../components/Wrapper";
import Loading from "../../../../components/Loading";
import Select from "../../../../components/Select";
import cloneDeep from "lodash/cloneDeep";
import "./index.css";
import { checkMinMax, priceNumbers } from "../../../../controllers";
import {
  salahiatKeyfariOptions,
  mojazatKeyfariOptions,
} from "../../../../reducer/selectOptions";
import { showPrice } from "../../../../global/functions";

class CriminalLawsuits extends Component {
  constructor(props) {
    super(props);
    this.state = {
      price: {
        value: props.keyfari["hoghooghPaye"].toLocaleString(),
        min: "minHagholvekale",
        max: "maxHagholvekale",
      },
      tableInput: {
        farjamKhahiKeyfariValue: "",
        omoorEjraiiValue: "",
        gharareGhabeleEterazeDadsaraValue: "",
        taghazaEadehdadresiValue: "",
        madde477Value: "",
      },
      tableItem: [
        {
          title: "دادسرا",
          value: "dadsara",
          showPrice: {
            value: "dadsaraCost",
            subsetOf: "footer",
          },
          changePrice: null,
          disable: false,
          prependCheckbox: null,
        },
        {
          title: "حکم بدوی قطعی",
          value: "badviGhatii",
          showPrice: null,
          changePrice: null,
          disable: false,
          prependCheckbox: null,
        },
        {
          title: "بدوی",
          value: "badvi",
          showPrice: {
            value: "badviCost",
            subsetOf: "footer",
          },
          changePrice: null,
          disable: false,
          prependCheckbox: null,
        },
        {
          title: "تجدید نظر",
          value: "tajdidNazar",
          showPrice: {
            value: "tajdidNazarCost",
            subsetOf: "footer",
          },
          changePrice: null,
          disable: false,
          prependCheckbox: null,
        },
        {
          title: "فرجام خواهی کیفری",
          value: "farjamKhahiKeyfari",
          showPrice: {
            value: "farjamKhahiKeyfariCost",
            subsetOf: "footer",
          },
          changePrice: {
            value: "farjamKhahiKeyfariValue",
            min: "minFarjamKeyfari",
            max: "maxFarjamKeyfari",
          },
          disable: false,
          prependCheckbox: null,
        },
        {
          title: "امور اجرایی",
          value: "omoorEjraii",
          showPrice: {
            value: "omoorEjraiiCost",
            subsetOf: "footer",
          },
          changePrice: {
            value: "omoorEjraiiValue",
            min: "minEjra",
            max: "maxEjra",
          },
          disable: false,
          prependCheckbox: null,
        },
        {
          title: "اعتراض به قرار های قابل اعتراض دادسرا",
          value: "gharareGhabeleEterazeDadsara",
          showPrice: {
            value: "gharareGhabeleEterazeDadsaraCost",
            subsetOf: "footer",
          },
          changePrice: {
            value: "gharareGhabeleEterazeDadsaraValue",
            min: "minGharareGHabeleEterazeDadsara",
            max: "maxGharareGHabeleEterazeDadsara",
          },
          disable: false,
          prependCheckbox: null,
        },
        {
          title: "تقاضای اعاده دادرسی",
          value: "taghazaEadehdadresi",
          showPrice: {
            value: "taghazaEadehDadresiCost",
            subsetOf: "footer",
          },
          changePrice: {
            value: "taghazaEadehdadresiValue",
            min: "minEadehdadresi",
            max: "maxEadehdadresi",
          },
          disable: false,
          prependCheckbox: null,
        },
        {
          title: "تقاضای اعمال ماده 477 آیین دادرسی کیفری",
          value: "madde477",
          showPrice: {
            value: "taghazaMade477Cost",
            subsetOf: "footer",
          },
          changePrice: {
            value: "madde477Value",
            min: "minMade477",
            max: "maxMade477",
          },
          disable: false,
          prependCheckbox: null,
        },
      ],
    };
  }
  componentDidUpdate(prevProps, prevState) {
    const { keyfari, sendData, setMinMax } = this.props;
    if (
      keyfari.salahiat !== prevProps.keyfari.salahiat ||
      keyfari.mojazat !== prevProps.keyfari.mojazat
    ) {
      setMinMax(2);
    }
    if (JSON.stringify(keyfari) !== JSON.stringify(prevProps.keyfari)) {
      sendData("Keyfari");
    }
  }
  render() {
    const { price, tableItem, tableInput } = cloneDeep(this.state);
    const { keyfari, setKeyfari, minMax, footer, loadign } = cloneDeep(
      this.props
    );
    return (
      <Wrapper>
        <header className="CriminalLawsuits flex flex-center py-4">
          <div className="flex column ml-5">
            <div className="flex align-center mb-3">
              <label className="text-normal m-0 ml-2">صلاحیت:</label>
              <Select
                value={keyfari["salahiat"]}
                setValue={(e) => {
                  keyfari["salahiat"] = Number(e.target.value);
                  setKeyfari(keyfari);
                }}
                items={salahiatKeyfariOptions}
              />
            </div>
            <div className="flex align-center">
              <label className="text-normal m-0 ml-2">مجازات:</label>
              <Select
                value={keyfari["mojazat"]}
                setValue={(e) => {
                  keyfari["mojazat"] = Number(e.target.value);
                  setKeyfari(keyfari);
                }}
                items={mojazatKeyfariOptions}
              />
            </div>
          </div>
          <Counter
            value={keyfari["tedadJaraemeEzafeh"]}
            setValue={(value) => {
              keyfari["tedadJaraemeEzafeh"] = value;
              setKeyfari(keyfari);
            }}
            title="تعداد جرایم اضافه"
          />
        </header>
        <main className="flex column flex-center mt-2">
          <div className="flex align-center justify-between full-width mt-4">
            <div className="align-center"></div>
            <Input
              value={price.value}
              onChange={(e) => {
                var value = e.target.value;
                keyfari["hoghooghPaye"] = Number(
                  priceNumbers(value).replace(/[^0-9.]/g, "")
                );
                setKeyfari(keyfari);
                price.value = priceNumbers(value);
                this.setState({ price });
              }}
              append="ریال"
              prepend="حق الوکاله پایه"
              inputClassName="text-center dir-ltr"
            />
            <div
              className={`text-${
                checkMinMax(
                  keyfari["hoghooghPaye"],
                  minMax[price.min],
                  minMax[price.max]
                )
                  ? "success"
                  : "danger"
              } flex flex-center`}
            >
              {loadign ? (
                <Loading />
              ) : (
                <>
                  {" "}
                  حداقل مبلغ {minMax[price.min].toLocaleString()} ریال و حداکثر
                  مبلغ {minMax[price.max].toLocaleString()} ریال وارد کنید
                </>
              )}
            </div>
          </div>
          <table className="mt-4 text-normal">
            <tbody>
              <tr>
                <td>
                  <Checkbox
                    value={keyfari["faghedDadsara"]}
                    setValue={() => {
                      keyfari["faghedDadsara"] = !keyfari["faghedDadsara"];
                      setKeyfari(keyfari);
                    }}
                    title="رسیدگی فاقد مرحله دادسرا"
                  />
                </td>
              </tr>
              {tableItem.map((item, index) => (
                <tr key={index}>
                  <td>
                    <Checkbox
                      title={item.title}
                      disable={item.disable}
                      value={keyfari[item.value]}
                      setValue={() => {
                        keyfari[item.value] = !keyfari[item.value];
                        setKeyfari(keyfari);
                      }}
                    />
                  </td>
                  {item.showPrice !== null ? (
                    <td>
                      {showPrice(
                        eval(item.showPrice.subsetOf),
                        item.showPrice.value
                      )}
                    </td>
                  ) : null}
                  {item.changePrice !== null ? (
                    <td>
                      <Input
                        value={tableInput[item.changePrice.value]}
                        onChange={(e) => {
                          keyfari[item.changePrice.value] = Number(
                            priceNumbers(e.target.value).replace(/[^0-9.]/g, "")
                          );
                          setKeyfari(keyfari);
                          tableInput[item.changePrice.value] = priceNumbers(
                            e.target.value
                          );
                          this.setState({ tableInput });
                        }}
                        inputClassName="text-center dir-ltr"
                        append="ریال"
                        disabled={!keyfari[item.value]}
                        error={{
                          show: keyfari[item.value],
                          color: checkMinMax(
                            keyfari[item.changePrice.value],
                            minMax[item.changePrice.min],
                            minMax[item.changePrice.max]
                          )
                            ? "success"
                            : "danger",
                          content: `حداقل ${minMax[
                            item.changePrice.min
                          ].toLocaleString()} و حداکثر ${minMax[
                            item.changePrice.max
                          ].toLocaleString()} ریال`,
                        }}
                      />
                    </td>
                  ) : null}
                </tr>
              ))}
            </tbody>
          </table>
        </main>
      </Wrapper>
    );
  }
}

let mapStateToProps = (state) => ({
  keyfari: state.keyfari,
  footer: state.footer,
  minMax: state.minMax,
  loadign: state.loadign,
});
let mapDispatchToProps = (dispatch) => ({
  setKeyfari: (data) => {
    dispatch({ type: "SET_KEYFARI", data });
  },
  setMinMax: (data) => {
    dispatch({ type: "SET_MINMAX", data });
  },
  sendData: (data) => {
    dispatch({ type: "SEND_DATA", data });
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(CriminalLawsuits);
